import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { returnParseProjectElement } from "../../../helpers/project.controller";
import { WarehousesController } from "../warehouses/warehouses.controller";
import { Row, Col, Typography, Switch, Divider, Button, Tag } from "antd";
import controller from "./loadManagementController"
import { EditOutlined } from "@ant-design/icons";
import i from "../../../translations/i";
import { Titles } from "../../../layouts/Titles";
import { useParams } from "react-router-dom";
import { ParamTypes } from "../../../helpers/types.interfaces";

const Storage = new WarehousesController()

export const LoadManagement = observer(() => {

  const { warehouse_id }: any = useParams<ParamTypes>()

  return (
    <>
      <Titles
        title={i.t('loadManagement:title')}
        buttons={[]}
      />

      {warehouse_id
        ? <SettingWarehouse warehouse_id={warehouse_id} />
        : <>
          {returnParseProjectElement('warehouses_enabled', true) > 0 ? <WHList /> : <SettingWarehouse warehouse_id={null}/>}
        </>
      }
    </>
  )
})

const SettingWarehouse = observer(({warehouse_id} : any) => {

  useEffect(() => {
    controller.get(warehouse_id)
    if(warehouse_id) Storage.getElement(warehouse_id)
  }, [])

  return(
    <Row gutter={[30, 30]}>
      <Col span={24}>
        <Typography.Title level={3}>{Storage.element.name}</Typography.Title>
      </Col>
      <Col span={24}>
        <Row gutter={[30, 30]}>
          <Col span={14}>
            <Row gutter={[30, 30]}>
              <Col span={24}>
                <Typography.Text strong>{i.t('loadManagement:kitchenTime')}</Typography.Text>
              </Col>
              <Col span={8}>
                <div className="loadManagementElement-set set" onClick={() => {
                  controller.item.kitchen -= 10
                  controller.save(warehouse_id)
                }}>
                  <Typography.Text strong>{i.t('loadManagement:minus10Minutes')}</Typography.Text>
                </div>
              </Col>
              <Col span={8}>
                <div className="loadManagementElement-set">
                  <Typography.Text type={controller.item.kitchen > 0 ? 'danger' : controller.item.kitchen < 0 ? 'success' : 'secondary'} strong>{i.t('loadManagement:totalMinutes', { value: `${controller.item.kitchen > 0 ? '+' : ''}${controller.item.kitchen}` })}</Typography.Text>
                </div>
              </Col>
              <Col span={8}>
                <div className="loadManagementElement-set set" onClick={() => {
                  controller.item.kitchen += 10
                  controller.save(warehouse_id)
                }}>
                  <Typography.Text strong>{i.t('loadManagement:plus10Minutes')}</Typography.Text>
                </div>
              </Col>

              <Col span={24}>
                <Typography.Text strong>{i.t('loadManagement:deliveryTime')}</Typography.Text>
              </Col>
              <Col span={8}>
                <div className="loadManagementElement-set set" onClick={() => {
                  controller.item.delivery -= 10
                  controller.save(warehouse_id)
                }}>
                  <Typography.Text strong>{i.t('loadManagement:minus10Minutes')}</Typography.Text>
                </div>
              </Col>
              <Col span={8}>
                <div className="loadManagementElement-set">
                  <Typography.Text type={controller.item.delivery > 0 ? 'danger' : controller.item.delivery < 0 ? 'success' : 'secondary'} strong>{i.t('loadManagement:totalMinutes', { value: `${controller.item.delivery > 0 ? '+' : ''}${controller.item.delivery}` })}</Typography.Text>
                </div>
              </Col>
              <Col span={8}>
                <div className="loadManagementElement-set set" onClick={() => {
                  controller.item.delivery += 10
                  controller.save(warehouse_id)
                }}>
                  <Typography.Text strong>{i.t('loadManagement:plus10Minutes')}</Typography.Text>
                </div>
              </Col>
              <Col span={12}>
                <Button
                  danger={!controller.item.stop_delivery}
                  onClick={() => {
                    controller.item.stop_delivery = !controller.item.stop_delivery
                    controller.save(warehouse_id)
                  }}
                  block
                >
                  {controller.item.stop_delivery ? i.t('loadManagement:startDelivery') : i.t('loadManagement:stopDelivery')}
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  danger={!controller.item.stop_orders}
                  onClick={() => {
                    controller.item.stop_orders = !controller.item.stop_orders
                    controller.save(warehouse_id)
                  }}
                  block
                >
                  {controller.item.stop_orders ? i.t('loadManagement:startAcceptOrders') : i.t('loadManagement:stopAcceptOrders')}
                </Button>
              </Col>
            </Row>
          </Col>
          <Col span={10}>
            <Row gutter={[20, 20]}>
              <Col span={24}>
                <Typography.Title level={4}>{i.t('delivery:typePickup')}</Typography.Title>
              </Col>
              <Col span={24}>
                <Row gutter={[20, 20]}>
                  {controller.item.pickup && controller.item.pickup.map((place_info: any) => (
                    <Col span={24}>
                      <Typography.Text strong>{place_info.place.name}</Typography.Text><br/>
                      {/*<Typography.Text>{new Date(place_info.interval.time_start * 1000).toISOString().slice(11, 16)} - {new Date(place_info.interval.time_end * 1000).toISOString().slice(11, 16)}</Typography.Text><br/>*/}

                      <Typography.Text>
                        {new Date(place_info.interval.time_start * 1000).getHours().toString().padStart(2, '0')}:
                        {new Date(place_info.interval.time_start * 1000).getMinutes().toString().padStart(2, '0')} -
                        {new Date(place_info.interval.time_end * 1000).getHours().toString().padStart(2, '0')}:
                        {new Date(place_info.interval.time_end * 1000).getMinutes().toString().padStart(2, '0')}
                      </Typography.Text><br/>

                      <Typography.Text>{i.t('loadManagement:assemblyTimeLabel')}<Tag>{place_info.interval.assembly_time}</Tag></Typography.Text>
                      <br/>
                      <Typography.Text>{i.t('loadManagement:intervalIdLabel')}<Tag>{place_info.interval.id}</Tag></Typography.Text>
                    </Col>
                  ))}
                </Row>
              </Col>
              <Col span={24}>
                <Typography.Title level={4}>{i.t('delivery:typeDelivery')}</Typography.Title>
              </Col>
              <Col span={24}>
                <Row gutter={[20, 20]}>
                  {controller.item._delivery && controller.item._delivery.map((place_info: any) => (
                    <Col span={24}>
                      <Typography.Text strong>{place_info.zone.name}</Typography.Text><br/>
                      {/*<Typography.Text>{new Date(place_info.interval.time_start * 1000).toISOString().slice(11, 16)} - {new Date(place_info.interval.time_end * 1000).toISOString().slice(11, 16)}</Typography.Text><br/>*/}
                      <Typography.Text>
                        {new Date(place_info.interval.time_start * 1000).getHours().toString().padStart(2, '0')}:
                        {new Date(place_info.interval.time_start * 1000).getMinutes().toString().padStart(2, '0')} -
                        {new Date(place_info.interval.time_end * 1000).getHours().toString().padStart(2, '0')}:
                        {new Date(place_info.interval.time_end * 1000).getMinutes().toString().padStart(2, '0')}
                      </Typography.Text><br/>
                      <Typography.Text>{i.t('loadManagement:assemblyTimeLabel')}<Tag>{place_info.interval.assembly_time}</Tag></Typography.Text>
                      <br/>
                      <Typography.Text>{i.t('loadManagement:intervalIdLabel')}<Tag>{place_info.interval.id}</Tag></Typography.Text>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  )
})

const WHList = observer(() => {

  useEffect(() => {
    controller.getWarehousesInfo()
    Storage.get(1000)
  }, [])

  return (
    <Row gutter={[20, 20]}>
      <Col span={24}>
        <Row gutter={[15, 15]}>
          <Col span={7}>
            <Typography.Text strong>{i.t('def:warehouse')}</Typography.Text>
          </Col>
          <Col span={4}>
            <Typography.Text strong>{i.t('loadManagement:kitchenTime')}</Typography.Text>
          </Col>
          <Col span={4}>
            <Typography.Text strong>{i.t('loadManagement:deliveryTime')}</Typography.Text>
          </Col>
          <Col span={3}>
            <Typography.Text strong>{i.t('delivery:typeDelivery')}</Typography.Text>
          </Col>
          <Col span={3}>
            <Typography.Text strong>{i.t('loadManagement:acceptOrders')}</Typography.Text>
          </Col>
          <Col span={3}>

          </Col>
        </Row>
      </Col>
      {Storage.list.map((el: any, index: number) => {

        let info = controller.warehousesInfo.find((item: any) => item.warehouse_id === el.id)

        if(!info) {
          info = {
            kitchen: 0,
            delivery: 0,
            stop_delivery: false,
            stop_orders: false
          }
        }

        return (<Col span={24} className="loadManagementElement" key={`loadManagementElement_${index}`}>
          <Divider dashed />
          <Row gutter={[30, 30]}>
            <Col span={7}>
              <Typography.Text strong>#{el.id} {el.name}</Typography.Text>
            </Col>
            <Col span={4}>
              <Typography.Text type={info.kitchen > 0 ? 'danger' : info.kitchen < 0 ? 'success' : 'secondary'}>{info.kitchen === 0 ? i.t('loadManagement:noChanges') : `${info.kitchen > 0 ? '+' : ''}${info.kitchen} ${i.t('def:minutes')}`}</Typography.Text>
            </Col>
            <Col span={4}>
              <Typography.Text type={info.delivery > 0 ? 'danger' : info.delivery < 0 ? 'success' : 'secondary'}>{info.delivery === 0 ? i.t('loadManagement:noChanges') : `${info.delivery > 0 ? '+' : ''}${info.delivery} ${i.t('def:minutes')}`}</Typography.Text>
            </Col>
            <Col span={3}>
              <Switch
                value={!info.stop_delivery}
                size="small"
                onChange={(e) => {
                  info.stop_delivery = !e
                  controller.setBool(el.id, info)
                }}
              />
            </Col>
            <Col span={3}>
              <Switch
                value={!info.stop_orders}
                size="small"
                onChange={(e) => {
                  info.stop_orders = !e
                  controller.setBool(el.id, info)
                }}
              />
            </Col>
            <Col span={3}>
              <Button
                icon={<EditOutlined />}
                shape="circle"
                type="dashed"
                href={`/settings/load_management/${el.id}`}
              />
            </Col>
          </Row>
        </Col>)
      })}
    </Row>
  )
})